import { formatToDdMmYyyy } from '@/utils';
import type {
  LC_OpenCutYearOut,
  LC_OpenCutMonthOut,
  LC_OpenCutDescriptionOut,
  LC_RecalculationProcessStatusOut,
  LC_ProcessHistoryItemOut,
  OpenCutYear,
  OpenCutMonth,
  OpenCutDescription,
  RecalculationProcessStatus,
  ProcessHistoryItem,
} from '../types';


export const mapOpenCutYear = (item: LC_OpenCutYearOut): OpenCutYear => ({
  year: item.year,
});

export const mapOpenCutMonth = (item: LC_OpenCutMonthOut): OpenCutMonth => ({
  month: item.month,
});

export const mapOpenCutDescription = (item: LC_OpenCutDescriptionOut): OpenCutDescription => ({
  monthlyCutId: item.id,
  description: item.description,
});

export const mapRecalculationProcessStatus = (
  item: LC_RecalculationProcessStatusOut,
): RecalculationProcessStatus => ({
  monthlyCutId: item.monthlyCutId,
  monthlyCutYear: item.monthlyCutYear,
  monthlyCutMonth: item.monthlyCutMonth,
  cutDescription: item.monthlyCutDescription,
  totalEmployees: item.totalEmployees,
  completedEmployees: item.completedEmployees,
  executionDate: formatToDdMmYyyy(item.createdAt),
  completionDate: item.completedAt ? formatToDdMmYyyy(item.completedAt) : null,
  adminName: item.adminName,
  processedCompanies: item.processedCompanies,
  stoppedBy: item.stoppedBy ?? null,
  status: item.status,
  progressPercentage: item.progressPercentage,
});

export const mapProcessHistoryItem = (item: LC_ProcessHistoryItemOut): ProcessHistoryItem => ({
  historyProcessId: item.historyProcessId,
  processId: item.processId,
  cutYear: item.cutYear,
  cutMonth: item.cutMonth,
  cutDescription: item.cutDescription,
  totalEmployees: item.totalEmployees,
  processedEmployees: item.processedEmployees,
  executionDate: formatToDdMmYyyy(item.executionDate),
  completionDate: item.completionDate ? formatToDdMmYyyy(item.completionDate) : null,
  executedBy: item.executedBy,
  processedCompanies: item.processedCompanies,
  stoppedBy: item.stoppedBy ?? null,
  status: item.status,
});
